import { gql } from '@apollo/client';

import { threadAnswerFragment } from '../fragments';

export default gql`
  query GetThreadAnswers($courseId: String, $threadId: String!) {
    threadAnswers(courseId: $courseId, threadId: $threadId)
      @rest(
        type: "ThreadAnswer"
        path: "/courses/{args.courseId}/threads/{args.threadId}/answers"
      ) {
      ...ThreadAnswer
    }
  }
  ${threadAnswerFragment}
`;
